import { defineComponent as w, useSlots as y, ref as p, computed as S, openBlock as o, createBlock as b, unref as s, withCtx as h, renderSlot as m, createElementBlock as l, createElementVNode as a, normalizeStyle as v, createCommentVNode as x, Fragment as B, renderList as N } from "vue";
import "./ghl-ui.es433.js";
import P from "./ghl-ui.es178.js";
import $ from "./ghl-ui.es215.js";
const E = {
  key: 1,
  class: "hl-color-picker__trigger"
}, L = { class: "hl-color-picker-dropdown-container" }, V = {
  key: 0,
  class: "hl-color-picker-header"
}, z = { class: "hl-colors-list" }, A = ["onClick"], F = w({
  __name: "SwatchesPicker",
  props: {
    swatches: {
      type: Array,
      default: void 0
    },
    trigger: {
      type: String,
      default: "click"
    },
    placement: {
      type: String,
      default: "bottom"
    },
    value: {
      type: String,
      default: void 0
    }
  },
  emits: ["onClickColor"],
  setup(t, { emit: g }) {
    const i = y(), n = t, c = p();
    n.swatches.length ? c.value = n.swatches.map((e) => e.toLowerCase().trim()).filter((e, u, r) => r.indexOf(e) === u) : c.value = [];
    const d = p(), k = S(() => d.value), f = g, C = (e) => {
      d.value = e, f("onClickColor", e);
    };
    return (e, u) => (o(), b(s($), {
      ref: "popper",
      raw: "",
      trigger: t.trigger,
      placement: t.placement,
      value: t.value,
      class: "hl-color-picker-popover",
      "show-arrow": !1
    }, {
      trigger: h(() => [
        s(i).trigger ? m(e.$slots, "trigger", {
          key: 0,
          value: t.value
        }, void 0, !0) : (o(), l("div", E, [
          a("span", {
            class: "hl-color-picker__selected-swatch",
            style: v({ backgroundColor: k.value })
          }, null, 4)
        ]))
      ]),
      default: h(() => [
        a("div", L, [
          s(i).header ? (o(), l("div", V, [
            m(e.$slots, "header", {}, void 0, !0)
          ])) : x("", !0),
          a("div", z, [
            (o(!0), l(B, null, N(c.value, (r, _) => (o(), l("div", {
              class: "hl-color-circle",
              key: _,
              style: v({ backgroundColor: r }),
              onClick: (I) => C(r)
            }, null, 12, A))), 128))
          ])
        ])
      ]),
      _: 3
    }, 8, ["trigger", "placement", "value"]));
  }
}), G = /* @__PURE__ */ P(F, [["__scopeId", "data-v-b04740c4"]]);
export {
  G as default
};
